import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { BannerService } from '../../../services/banner.service';
import { FileUpload } from 'primeng/fileupload';
import { HttpClient } from '@angular/common/http';
import { environment } from "./../../../../environments/environment";
import { Observable } from 'rxjs';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-banner-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  providers: [ConfirmationService, MessageService, BannerService]
})

export class BannerAddComponent implements OnInit, OnDestroy {
  showInstructionModal: boolean = false;
  private destroy$ = new Subject<void>();
  uploadedFiles: any[] = [];
  banner_image: FormArray;
  deletedattachments: any[] = [];
  filename: any = '';
  staticPath: string;
  bannerImage: any = [];
  statuses: any;
  submitted = false;
  id: string;
  isAddMode: boolean;
  pagetitle: string;
  public isUpload: boolean = false;
  banner_content;
  banner_title;
  banner_url;
  bannerstatus: any;
  bannerImagesArray: any;
  mobileBannerImagesArray: any;
  banners: any[] = [
    { name: 'Banner 1', value: 'Banner 1' },
    { name: 'Banner 2', value: 'Banner 2' },
    { name: 'Banner 3', value: 'Banner 3' }
  ];
  selectedbannername: any = this.banners[0].value;
  bannerForm: FormGroup;
  public loggedInUser;
  public userId;
  public userRoleId;
  public bannerModule;
  public loggedInUserPermissions;
  public bannerPermissions: any[] = [];
  public mobileBannerImage: any[] = [];
  public mobileUploadedFiles: any[] = [];
  sampleBannerImageLinkArray: any[] = [];
  sampleMobileBannerImageLinkArray: any[] = [];
  bannerImageTypes: { label: string; value: string; }[];
  @ViewChild('fileUpload1') fileUpload1!: FileUpload;
  @ViewChild('fileUpload2') fileUpload2!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageSize = 1000000;
  croppedImageMaxSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  imageQueue: any[] = [];
  currentImageIndex: number = 0;
  cropDialog: boolean = false;
  fileUploader: 'webBannerImage' | 'mobileBannerImage' | string = 'webBannerImage';
  scale = 1;
  transform: ImageTransform = {};
  isApplyingCrop = false;
  batchCropCompleted = false;
  private cropApplyUnlockTimer: any = null;

  get cropDialogTitle(): string {
    return this.fileUploader === 'webBannerImage'
      ? 'Crop & Adjust Web Banner Image'
      : 'Crop & Adjust Mobile Banner Image';
  }

  get cropDialogSubtitle(): string {
    const progress = this.imageQueue.length > 1
      ? `Photo ${this.currentImageIndex + 1} of ${this.imageQueue.length} - `
      : '';
    const size = this.fileUploader === 'webBannerImage' ? '1024 x 512' : '1500 x 1050';
    return `${progress}position and scale your image for a ${size} crop`;
  }

  get cropPreviewLabel(): string {
    return this.fileUploader === 'webBannerImage'
      ? '1024 x 512 px - High Quality JPEG'
      : '1500 x 1050 px - High Quality JPEG';
  }

  zoomIn() {
    this.scale = Math.min(3, Number((this.scale + 0.1).toFixed(1)));
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    this.scale = Math.max(0.1, Number((this.scale - 0.1).toFixed(1)));
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  showSafeGuide: boolean = true;

  toggleSafeGuide() {
    this.showSafeGuide = !this.showSafeGuide;
  }

  resetZoom() {
    this.scale = 1;
    this.transform = {
      ...this.transform,
      scale: 1
    };
  }

  constructor(
    private BannerService: BannerService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    private httpClient: HttpClient,
    private messageService: MessageService,
    private tokenStorageService: TokenStorageService,
    private elementRef: ElementRef
  ) { }
  @ViewChild('fileInput') fileInput: FileUpload;
  ngOnInit() {

    this.loggedInUser = this.tokenStorageService.getUser();
    this.userId = this.loggedInUser.userdata.id;
    this.userRoleId = this.loggedInUser.userdata.role;

    this.bannerModule = "Banner Management";
    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();

    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.bannerModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.bannerPermissions.push(permissionObj);
      }
    });
    if (this.bannerPermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }
    this.bannerPermissions = this.bannerPermissions[0]['permission'];

    this.staticPath = environment.uploadUrl;
    this.pagetitle = 'Add Banner';
    this.id = this.route.snapshot.paramMap.get("id");
    this.isAddMode = !this.id;
    this.statuses = [
      { name: 'Active', code: 'Active' },
      { name: 'In-Active', code: 'In-Active' }
    ];
    this.bannerImageTypes = [
      { label: 'Internal', value: 'Internal' },
      { label: 'External', value: 'External' }
    ];
    //this.bannerstatus = "Active";
    this.bannerForm = this.formBuilder.group({
      banner_title: ['', [Validators.required, Validators.pattern('^[A-Za-z_ ][A-Za-z_ ]*$')]],
      slug: ['', [Validators.required, Validators.pattern('^[A-Za-z_][A-Za-z_]*$')]],
      mobile_banner_title: ['', [Validators.required, Validators.pattern('^[A-Za-z_ ][A-Za-z_ ]*$')]],
      mobile_slug: ['', [Validators.required, Validators.pattern('^[A-Za-z_][A-Za-z_]*$')]],
      // banner_content: [''],
      // banner_url: ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      banner_image_links: this.formBuilder.array([]),
      mobile_banner_image_links: this.formBuilder.array([]),
      status: [true, Validators.required],
      disable: [false],
    });
  }

  bannerImageLinksArray() {
    return this.bannerForm.get('banner_image_links') as FormArray;
  }

  mobileBannerImageLinksArray() {
    return this.bannerForm.get('mobile_banner_image_links') as FormArray;
  }

  get f() {
    return this.bannerForm.controls;
  }
  onUpload(event, frmCrl, form) {
    this.uploadedFiles = []
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.isUpload = true;
    this.changeDetectorRef.detectChanges();
  }
  deleteFile(list, index) {
    this.deletedattachments.push(this.uploadedFiles[index]);
    this.uploadedFiles.splice(index, 1);
    this.fileInput.files.splice(index, 1);
  }
  setUploadedFiles(fileData: any = '') {
    fileData.forEach(file => {
      // console.log(file);
      let filePath = environment.uploadUrl + file;
      this.loadFile(filePath).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe(i => {
        var file = new File([i], filePath.split("/").pop(), { type: i.type, lastModified: Date.now() });
        this.fileInput.files.push(file);
        this.uploadedFiles.push(file);
      });
    });
  }
  loadFile(filepath): Observable<Blob> {
    return this.httpClient.get(filepath, {
      responseType: "blob"
    });
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.bannerForm.invalid) {
      return;
    }
    var bannerData = this.bannerForm.value;
    //bannerData['status'] =this.bannerstatus;
    //console.log(this.bannerImage);
    this.bannerImagesArray = [];
    this.mobileBannerImagesArray = [];
    if (this.bannerImage != undefined) {
      this.bannerImage.forEach((element, index) => {
        index = index + 1;
        let bannerImageAlt = null;
        let bannerImageDefault = null;
        // let bannerImageAlt = this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_image_" + index).value;
        // let bannerImageDefault = this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).checked;
        this.bannerImagesArray.push({ 'file': element.file, 'alt': bannerImageAlt, 'default': bannerImageDefault });

      });
    }

    this.bannerImageLinksArray().value.forEach((ele, index) => {
      this.bannerImagesArray[index]['order'] = ele['order'];
      this.bannerImagesArray[index]['bannerImageLink'] = ele['bannerImageLink'];
      this.bannerImagesArray[index]['bannerImageLinkType'] = ele['bannerImageLinkType']?.value ?? null;
    })

    if (this.mobileBannerImage != undefined) {
      this.mobileBannerImage.forEach((element, index) => {
        index = index + 1;
        let bannerImageAlt = null;
        let bannerImageDefault = null;
        // let bannerImageAlt = this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_image_" + index).value;
        // let bannerImageDefault = this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).checked;
        this.mobileBannerImagesArray.push({ 'file': element.file, 'alt': bannerImageAlt, 'default': bannerImageDefault });

      });
    }

    this.mobileBannerImageLinksArray().value.forEach((ele, index) => {
      this.mobileBannerImagesArray[index]['order'] = ele['order'];
      this.mobileBannerImagesArray[index]['mobileBannerImageLink'] = ele['mobileBannerImageLink'];
      this.mobileBannerImagesArray[index]['mobileBannerImageLinkType'] = ele['mobileBannerImageLinkType']?.value ?? null;
    })
    //console.log('this.bannerImagesArray', this.bannerImagesArray);

    bannerData['banner_images'] = this.bannerImagesArray;
    bannerData['mobile_banner_images'] = this.mobileBannerImagesArray;
    delete bannerData['banner_image_links'];
    delete bannerData['mobile_banner_image_links'];
    //display form values on success
    // console.log(JSON.stringify(this.bannerForm.value, null, 4));
    bannerData = JSON.stringify(bannerData, null, 4);
    this.BannerService.addBanner(bannerData).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Banner Added Successfully!!', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/manage/banner']);
        }, 2000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
      })
    );
  }
  onchangeSelect(event) {
    this.selectedbannername = event.value.value;
    this.changeDetectorRef.detectChanges();
  }
  onStatusSelect(event) {
    if (event) {
      this.bannerstatus = event.name;
    }
  }

  onMultipleFileSelect(event: any, fileUploaderName) {
    const files: File[] = Array.from(event.files || []);
    this.fileUploader = fileUploaderName;
    if (files.length === 0) {
      return;
    }
    const maxSize = 1 * 1024 * 1024;
    const validFiles: File[] = [];
    files.forEach((file: File) => {
      if (file.size > maxSize) {
        this.messageService.add({
          key: 'toastmsg',
          severity: 'error',
          summary: 'Image Too Large',
          detail: `${file.name} exceeds 1 MB`,
          life: 4000
        });
      } else {
        validFiles.push(file);
      }
    });
    this.clearFileInput();
    if (validFiles.length === 0) {
      return;
    }
    this.batchCropCompleted = false;
    this.isApplyingCrop = false;
    this.imageQueue = [...validFiles];
    this.currentImageIndex = 0;
    this.loadCropperImage();
  }

  loadCropperImage(fromQueueTransition: boolean = false) {
    this.clearCropApplyUnlockTimer();
    const file = this.imageQueue[this.currentImageIndex];
    if (!file) {
      this.cropDialog = false;
      return;
    }
    this.croppedImage = null;
    this.resetCropValidation();
    this.resetZoom();
    this.isApplyingCrop = fromQueueTransition;
    this.imageChangedEvent = {
      target: {
        files: [file]
      }
    };
    this.cropDialog = true;
    if (fromQueueTransition) {
      const expectedIndex = this.currentImageIndex;
      this.cropApplyUnlockTimer = setTimeout(() => {
        if (this.cropDialog && this.currentImageIndex === expectedIndex) {
          this.isApplyingCrop = false;
        }
        this.cropApplyUnlockTimer = null;
      }, 600);
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must not exceed 1 MB.'
      : null;
  }

  onCropImageLoadFailed() {
    this.croppedImage = null;
    this.croppedImageSize = 0;
    this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
  }

  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage) return;
    const currentFile = this.imageQueue[this.currentImageIndex];
    if (!currentFile) {
      this.croppedImageError = 'The selected image is no longer available. Cancel and choose it again.';
      return;
    }

    this.isApplyingCrop = true;
    const croppedFile = this.base64ToFile(
      this.croppedImage,
      this.getOutputFileName(currentFile.name)
    );
    if (croppedFile.size > this.croppedImageMaxSize) {
      this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
      this.isApplyingCrop = false;
      return;
    }

    const uploadEvent = { files: [croppedFile] };
    if (this.fileUploader === 'webBannerImage') {
      this.picUploader(uploadEvent);
    } else {
      this.mobilePicUploader(uploadEvent);
    }

    this.currentImageIndex++;
    if (this.currentImageIndex < this.imageQueue.length) {
      this.loadCropperImage(true);
    } else {
      this.finishUploadFlow();
    }
  }

  finishUploadFlow() {
    this.batchCropCompleted = true;
    this.cropDialog = false;
  }

  onCropCancel() {
    this.batchCropCompleted = false;
    this.cropDialog = false;
  }

  onDialogHide() {
    this.resetCropFlow();
  }

  private resetCropFlow() {
    this.clearCropApplyUnlockTimer();
    this.imageQueue = [];
    this.currentImageIndex = 0;
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.resetCropValidation();
    this.resetZoom();
    this.batchCropCompleted = false;
    this.isApplyingCrop = false;
    this.clearFileInput();
  }

  private clearCropApplyUnlockTimer() {
    if (this.cropApplyUnlockTimer) {
      clearTimeout(this.cropApplyUnlockTimer);
      this.cropApplyUnlockTimer = null;
    }
  }

  private clearFileInput() {
    if (this.fileUpload1) {
      this.fileUpload1.clear();
    }
    if (this.fileUpload2) {
      this.fileUpload2.clear();
    }
    const fileInputs = this.elementRef?.nativeElement?.querySelectorAll('input[type="file"]');
    if (fileInputs) {
      fileInputs.forEach((input: HTMLInputElement) => {
        input.value = '';
      });
    }
  }

  resetCropValidation() {
    this.croppedImageError = null;
    this.croppedImageSize = 0;
  }

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  private getOutputFileName(filename: string | undefined): string {
    const defaultPrefix = this.fileUploader === 'webBannerImage' ? 'web-banner' : 'mobile-banner';
    const timestamp = new Date().getTime();
    const baseName = (filename || defaultPrefix).replace(/\.[^/.]+$/, '');
    return `${baseName}_${timestamp}.jpg`;
  }

  picUploader(event) {
    let index = 0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // console.log(file.name);// called once readAsDataURL is completed
        if (reader.result != null) {
          this.bannerImage.push({
            'file': reader.result,
            'name': file.name,
            'size': file.size
          });
          index++;
          if (!this.sampleBannerImageLinkArray.includes(file.name)) {
            this.sampleBannerImageLinkArray.push(file.name);

            const bannerImageLinkFormGroup = this.formBuilder.group({
              order: [null, [Validators.required]],
              bannerImageLink: ['', Validators.pattern(/^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/)],
              bannerImageLinkType: [null]
            });
            this.bannerImageLinksArray().push(bannerImageLinkFormGroup);
          }
        }
      }
    }
  }

  removeUploadedBannerImage(index: number) {
    this.sampleBannerImageLinkArray.splice(index, 1);
    this.bannerImage.splice(index, 1);
    if (this.uploadedFiles && this.uploadedFiles[index]) {
      this.uploadedFiles.splice(index, 1);
    }
    this.bannerImageLinksArray().removeAt(index);
  }

  removeBannerImage(event) {
    const webBannerImageindex = this.sampleBannerImageLinkArray.findIndex(ele => ele === event.file.name);
    if (webBannerImageindex > -1) {
      this.removeUploadedBannerImage(webBannerImageindex);
    }
  }

  mobilePicUploader(event) {
    let index = 0;
    for (let file of event.files) {
      this.mobileUploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // console.log(file.name);// called once readAsDataURL is completed
        if (reader.result != null) {
          this.mobileBannerImage.push({
            'file': reader.result,
            'name': file.name,
            'size': file.size
          });
          index++;
          if (!this.sampleMobileBannerImageLinkArray.includes(file.name)) {
            this.sampleMobileBannerImageLinkArray.push(file.name);
            const mobileBannerImageLinkFormGroup = this.formBuilder.group({
              order: [null, [Validators.required]],
              mobileBannerImageLink: ['', Validators.pattern(/^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/)],
              mobileBannerImageLinkType: [null]
            });
            this.mobileBannerImageLinksArray().push(mobileBannerImageLinkFormGroup);
          }
        }
      }
    }
  }

  removeUploadedMobileBannerImage(index: number) {
    this.sampleMobileBannerImageLinkArray.splice(index, 1);
    this.mobileBannerImage.splice(index, 1);
    if (this.mobileUploadedFiles && this.mobileUploadedFiles[index]) {
      this.mobileUploadedFiles.splice(index, 1);
    }
    this.mobileBannerImageLinksArray().removeAt(index);
  }

  removeMobileBannerImage(event) {
    const mobileBannerImageindex = this.sampleMobileBannerImageLinkArray.findIndex(ele => ele === event.file.name);
    if (mobileBannerImageindex > -1) {
      this.removeUploadedMobileBannerImage(mobileBannerImageindex);
    }
  }

  formatFileSize(bytes: number): string {
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(3)) + ' ' + sizes[i];
  }

  onReset() {
    this.submitted = false;
    this.bannerForm.reset();
  }
  backLink() {
    this.router.navigate(['/manage/banner']);
  }

  ngOnDestroy() {
    this.clearCropApplyUnlockTimer();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
